import type { QueryClient, QueryKey } from '@tanstack/react-query';
import { getFallbackQueryClient } from './queryClient';

/**
 * Use this helper to eagerly refresh any query (active or inactive). This works by invalidating
 * the provided query key, and forcefully re-fetching it using the provided query options
 */
export async function refreshQuery(
  queryKey: QueryKey,
  queryClient?: QueryClient,
) {
  const client = queryClient ?? getFallbackQueryClient();
  await client.invalidateQueries({ queryKey });
}
